import ProjectDetails from "../components/ProjectDetails/ProjectDetails";

function ProjectDetailsPage() {
  return (
    <div
      style={{
        width: "100%",
      }}
    >
      <ProjectDetails />
    </div>
  );
}

export default ProjectDetailsPage;
